import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BaseFormTemplate from '../form-templates/BaseFormTemplate';
import formTemplateManager from '../form-templates/FormTemplateManager';
import Button from '../components/styled/Button';
import Card from '../components/styled/Card';
import { useNavigate } from 'react-router-dom';

const DailyFarmLogbookPage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);

  // Get the form template
  const template = formTemplateManager.getTemplate('daily-farm-logbook', t);
  const { title, description, fields } = template;

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    setSubmissionStatus(null);
    
    try {
      // Get the token from localStorage or context
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/forms`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          type: 'daily-farm-logbook',
          language: i18n.language,
          data: formData
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to submit form');
      }

      const result = await response.json();
      setSubmissionStatus({ type: 'success', message: t('form.submittedSuccessfully') || 'Form submitted successfully!' });
      
      // Reset form after successful submission
      setTimeout(() => {
        setSubmissionStatus(null);
        navigate('/dashboard'); // Navigate back to dashboard after success
      }, 2000);
    } catch (error) {
      console.error('Submission error:', error);
      setSubmissionStatus({ type: 'error', message: error.message || t('form.submissionError') || 'Error submitting form' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <Card className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">{t(title)}</h1>
          <p className="text-gray-600">{t(description)}</p>
        </div>

        {submissionStatus && (
          <div className={`mb-6 p-4 rounded-md ${submissionStatus.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
            {submissionStatus.message}
          </div>
        )}

        <BaseFormTemplate
          title={t(template.title)}
          description={t(template.description)}
          fields={fields}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          submitButtonText={t('form.submit') || 'Submit'}
          cancelButtonText={t('form.cancel') || 'Cancel'}
        />
      </Card>
    </div>
  );
};

export default DailyFarmLogbookPage;